import {Component, ViewChild} from '@angular/core';
import {NgForm} from '@angular/forms';
import {ReplaySubject} from 'rxjs';
import {StepScreenModel} from '../../../../shared/step/step-screen.component';
import {FormErrors} from '../../../../../components/forms/validation/form-validator.class';
import {ActivatedRoute} from '@angular/router';
import {BoardAffiliationInformationService} from '../../../../../domain/model/licenses-certifications/board/information/board-affiliation-information.service';
import {BoardAffiliationInformation} from '../../../../../domain/model/licenses-certifications/board/information/board-affiliation-information.model';
import {BoardScreensManager} from '../board-screens-manager.service';
import moment = require('moment');

@Component({
    template: require('./specialty-examination-screen.component.html')
})
export class SpecialtyExaminationScreenComponent {

    constructor(readonly modelService: BoardAffiliationInformationService,
                readonly route: ActivatedRoute,
                readonly screensManager: BoardScreensManager) {
    }

    // region Form
    readonly form$ = new ReplaySubject<NgForm>(1);

    @ViewChild(NgForm) set form(value: NgForm) {
        this.form$.next(value);
    }

    // endregion

    specialtyExaminationDateConstrains = {
        min: moment().subtract(10, 'year'),
        max: moment().add(10, 'year')
    };

    stepScreenModel = new StepScreenModel<BoardAffiliationInformation>({
        initialDataModel: new BoardAffiliationInformation(),
        specificValidationMessages: {},
        screensManager: this.screensManager,
        _loadDataFn: () => {
            return this.modelService.getCurrentUserModel();
        },
        _submitDataFn: (model: BoardAffiliationInformation) => {
            return this.modelService.updateCurrentUserModel(model);
        },
        _hasYesNoQuestion: () => this.stepScreenModel.dataModel$.map(it => it.specialtyExaminationDate === undefined)
    });

    get model(): BoardAffiliationInformation {
        return this.stepScreenModel.dataModel;
    }

    get formErrors(): FormErrors {
        return this.stepScreenModel.formErrors;
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/pages/licenses-certifications/steps/board/specialty-examination/specialty-examination-screen.component.ts